import React from "react";
import { Link } from "react-router-dom";
const NotFoundPage = () => (
  <div
    className="container"
    style={{
      maxWidth: 600,
      margin: "80px auto",
      textAlign: "center",
      padding: 32,
      background: "#fff",
      borderRadius: 16,
      boxShadow: "0 2px 16px #eee"
    }}
  >
    <h1 style={{ fontSize: 72, margin: 0, color: "#ff5959" }}>404</h1>
    <h2 style={{ margin: "18px 0" }}>Page Not Found</h2>
    <p style={{ color: "#888" }}>
      Sorry, the page you are looking for does not exist.
    </p>
    <Link
      to="/"
      style={{
        display: "inline-block",
        margin: "28px 0",
        color: "#3266ee",
        fontSize: 18,
        textDecoration: "underline"
      }}
    >
      Go to Homepage
    </Link>
    <div style={{ margin: "32px 0" }}>
    </div>
  </div>
);

export default NotFoundPage;
